/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var UsageDarkBlue = function UsageDarkBlue(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Usage icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['usage--dark-blue', 'usage--dark-blue-2', 'usage--dark-blue-3', 'usage--dark-blue-4', 'usage--dark-blue-5', 'usage--dark-blue-6', 'usage--dark-blue-7', 'usage--dark-blue-8', 'usage--dark-blue-9', 'usage--dark-blue-10', 'usage--dark-blue-11', 'usage--dark-blue-12', 'usage--dark-blue-13', 'usage--dark-blue-14', 'usage--dark-blue-15', 'usage--dark-blue-16'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 200"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-3'],
    x1: "66.98",
    x2: "66.98",
    y1: "5.67",
    y2: "200.03",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#f6f2ff",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".47",
    stopColor: "#bdccfe",
    stopOpacity: ".47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".81",
    stopColor: "#99b4fe",
    stopOpacity: ".81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8babfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8cacfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-4'],
    x1: "116.59",
    x2: "35.2",
    y1: "1826.57",
    y2: "1875.25",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".01",
    stopColor: "#545a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3a3b46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-5'],
    x1: "67.19",
    x2: "134",
    y1: "1834.3",
    y2: "1834.3",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#313437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#434251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-6'],
    x2: "67.24",
    y1: "1834.3",
    y2: "1834.3",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#28292d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3c3d40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-1'],
    x1: "48.46",
    x2: "21.52",
    y1: "156.14",
    y2: "139.79",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#232632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#2a2c34",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-7'],
    x1: "63.63",
    x2: "36.68",
    y1: "148.35",
    y2: "132.01",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-8'],
    x1: "79.47",
    x2: "52.53",
    y1: "139.85",
    y2: "123.5",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-9'],
    x1: "94.3",
    x2: "67.36",
    y1: "132.62",
    y2: "116.28",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-2'],
    x1: "41.22",
    x2: "126.46",
    y1: "25.59",
    y2: "230.57",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#324280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#908dd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-10'],
    x1: "53.24",
    x2: "86.63",
    y1: "1825.81",
    y2: "1900.81",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-11'],
    x1: "23.64",
    x2: "108.88",
    y1: "32.9",
    y2: "237.88",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-12'],
    x1: "39.95",
    x2: "70.22",
    y1: "1820.05",
    y2: "1888.03",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-13'],
    x1: "57.26",
    x2: "142.49",
    y1: "18.92",
    y2: "223.9",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-14'],
    x1: "66.09",
    x2: "101.9",
    y1: "1830.91",
    y2: "1911.35",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-15'],
    x1: "6.25",
    x2: "91.49",
    y1: "40.13",
    y2: "245.11",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--dark-blue-16'],
    x1: "28.85",
    x2: "54.15",
    y1: "1816.62",
    y2: "1873.43",
    gradientTransform: "matrix(1 0 0 -1 0 1997.29)",
    xlinkHref: "#".concat(gradientIds['usage--dark-blue-2'])
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-3'], ")"),
    d: "M66.76 102.24L134 141.17V0H0v141.17z",
    opacity: ".1",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-4'], ")"),
    d: "M0 141.07l66.77-38.93L134 141.07 67.24 180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-5'], ")"),
    d: "M134 141.07v4.9L67.19 184.9V180z",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-6'], ")"),
    d: "M67.24 180v4.9L0 146v-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillOpacity: ".3",
    d: "M67.19 184.9l-54.2-31.4L0 161.07 67.19 200l66.77-38.93-12.99-7.52-53.78 31.35z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-1'], ")"),
    d: "M16.01 139.4l4.21-2.42 31.44 18.15-4.21 2.42-31.44-18.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-7'], ")"),
    d: "M31.18 131.61l4.2-2.42 31.44 18.15-4.2 2.42-31.44-18.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-8'], ")"),
    d: "M47.02 123.11l4.21-2.42 31.44 18.15-4.21 2.42-31.44-18.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-9'], ")"),
    d: "M61.86 115.89l4.2-2.42 31.44 18.15-4.2 2.42-31.44-18.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-2'], ")"),
    d: "M74.27 78.93l4.19 2.43v59.9l-4.19-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-10'], ")"),
    d: "M78.47 81.36l4.2-2.43v59.91l-4.2 2.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a8e4",
    d: "M74.27 78.93l4.2-2.42 4.19 2.42-4.19 2.43-4.2-2.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-11'], ")"),
    d: "M58.43 93.44l4.19 2.42v53.9l-4.19-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-12'], ")"),
    d: "M62.62 95.86l4.2-2.43v53.91l-4.2 2.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a8e4",
    d: "M58.43 93.44l4.2-2.43 4.19 2.43-4.19 2.42-4.2-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-13'], ")"),
    d: "M89.1 67.05l4.2 2.43V134l-4.2-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-14'], ")"),
    d: "M93.3 69.47L97.5 67v64.58L93.3 134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a8e4",
    d: "M89.1 67.05l4.2-2.42 4.19 2.42-4.19 2.43-4.2-2.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-15'], ")"),
    d: "M43.26 110.78l4.19 2.43v44.34l-4.19-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['usage--dark-blue-16'], ")"),
    d: "M47.46 113.21l4.2-2.42v44.34l-4.2 2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a8e4",
    d: "M43.26 110.78l4.2-2.42 4.19 2.42-4.19 2.43-4.2-2.43z"
  }));
};
UsageDarkBlue.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var UsageDarkBlue$1 = UsageDarkBlue;

export { UsageDarkBlue$1 as default };
